module.exports = __webpack_public_path__ + "static/img/oi-logo.e63190d2.jpg";